module.exports = __webpack_public_path__ + "img/Demon_01.9216cd83.gif";